export default "__VITE_ASSET__XpO6EiLb__"